import { DOMAttributes, MutableRefObject } from 'react';
import { ShareMenu } from 'share-menu';

type CustomEvents<K extends string> = { [key in K]: (event: CustomEvent) => void };

type CustomElement<T, K extends string> = Partial<T & DOMAttributes<T> & { children: any } & { ref: MutableRefObject<any> } & CustomEvents<`on${K}`>>;

declare global {
  namespace JSX {
    interface IntrinsicElements {
      ['share-menu']: CustomElement<ShareMenu, any>;
    }
  }
}

export const ShareMenuModal = ({ shareModalRef, service }) => {
  if (!service?.service) return null;

  if (shareModalRef?.current) {
    // @ts-ignore
    shareModalRef.current.socials = ['clipboard', 'facebook', 'twitter', 'email', 'sms', 'skype'];
  }

  console.log(`FS: share dialog initialized for url ${service.share_url}`);

  return (
    <share-menu
      data-share-menu
      dialog-title="Share This Service"
      ref={shareModalRef}
      via="funeralstream"
      title={service.service.name}
      url={service.share_url}
    ></share-menu>
  );
};
